/// <reference types="@types/google.maps" />

import * as React from 'react';
import currentLocation from './currentLocation';
import { currentLocationPos } from '../../../../../interfaces/interfaces';

interface MapProps extends google.maps.MapOptions {
  style: { [key: string]: string };
  children?: React.ReactNode | React.ReactElement;
  setCurrentLocation(x: currentLocationPos | null): void;
}

const Map: React.FC<MapProps> = ({ children, style, setCurrentLocation, ...options }) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const [map, setMap] = React.useState<google.maps.Map>();

  React.useEffect(() => {
    if (ref.current && !map) {
      setMap(new window.google.maps.Map(ref.current));
    }
  }, [ref, map]);

  React.useEffect(() => {
    if (map) {
      map.setOptions(options);
    }
  }, [map, options]);

  React.useEffect(() => {
    const isCurrentPosition = sessionStorage.getItem('currentPosition');
    if (map && !isCurrentPosition) currentLocation(map, setCurrentLocation).getCurrentPosition();
  }, [map, setCurrentLocation]);

  return (
    <>
      <div ref={ref} style={style} />
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child as React.ReactElement, { map });
        }
        return null;
      })}
    </>
  );
};

export default Map;
